import React, { useState } from 'react';
import { MenuItem, Button } from '@material-ui/core';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { ArrowDropDown } from '@material-ui/icons';
import * as lib from '~/dependencies';
import { eventTracker } from '~/helpers';
import {
  BoxSelector,
  Values,
  Row,
  MenuContainer,
  ScrollableContainer,
} from './styles';

const countriesAssets = require('~/assets/countries/countries.json');

const allCountries = Object.keys(countriesAssets)
  .reduce(
    (prev, next) =>
      prev.concat({
        code: next,
        callingCode: countriesAssets[next].callingCode,
        flag: countriesAssets[next].flag,
        name: countriesAssets[next].name.common,
      }),
    []
  )
  .filter(e => e.callingCode !== undefined);

function filter(countries, search) {
  if (!countries?.length) return [];

  if (!search) return countries;

  const searchValue = search.toUpperCase().replace(/\+/g, '');

  // eslint-disable-next-line no-restricted-globals
  const isNumber = !isNaN(searchValue);

  if (isNumber) {
    // Search for country code which is number, e.g: +353
    const countriesByCodeNumber = countries.filter(
      e => e.callingCode && e.callingCode.startsWith(searchValue)
    );

    return countriesByCodeNumber;
  }

  if (searchValue.length <= 2) {
    // Search for country code which is letter, e.g: IE
    const countriesByCodeLetter = countries.filter(
      e => e.code && e.code.toUpperCase().includes(searchValue)
    );

    return countriesByCodeLetter;
  }

  //  Search for country by name
  const countriesByName = countries.filter(
    e => e.name && e.name.toUpperCase().includes(searchValue)
  );

  if (countriesByName?.length) return countriesByName;

  return countries;
}

export default function FlagSelector({ countryCode, setCountryCode }) {
  const [search, setSearch] = useState('');

  function clearSearch() {
    setTimeout(() => {
      setSearch('');
    }, 1200);
  }

  function handleOnChangeCountryCode(callingCode, code, popupState) {
    setCountryCode({
      callingCode,
      code,
    });
    popupState.close();
    clearSearch();
    eventTracker(events => events.ChangeCountry);
  }

  const indexCountry = allCountries.findIndex(
    e =>
      e.callingCode === countryCode.callingCode && e.code === countryCode.code
  );
  const flagSelected = indexCountry !== -1 ? allCountries[indexCountry] : [];

  const countriesFiltered = filter(allCountries, search);

  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {popupState => (
        <>
          <Button {...bindTrigger(popupState)}>
            <BoxSelector>
              <Values>
                <Row>
                  <img src={flagSelected.flag} alt="flag" className="flag" />
                  <span>{`${flagSelected.code} +${flagSelected.callingCode}`}</span>
                </Row>
              </Values>
              <ArrowDropDown className="icon-arrow" />
            </BoxSelector>
          </Button>
          <MenuContainer
            {...bindMenu(popupState)}
            PaperProps={{
              style: {
                maxHeight: 350,
              },
            }}>
            <MenuItem className="input-container">
              <input
                type="text"
                value={search}
                onChange={text => setSearch(text.target.value)}
                placeholder="Code or name"
                // eslint-disable-next-line
                autoFocus
              />
            </MenuItem>
            <ScrollableContainer>
              {countriesFiltered?.map(e => (
                <MenuItem
                  value={e.callingCode}
                  key={e.code}
                  onClick={() =>
                    handleOnChangeCountryCode(e.callingCode, e.code, popupState)
                  }>
                  <img src={e.flag} alt="flag" className="flag" />
                  <span>{`${e.code} +${e.callingCode}`}</span>
                </MenuItem>
              ))}
            </ScrollableContainer>
          </MenuContainer>
        </>
      )}
    </PopupState>
  );
}

FlagSelector.defaultProps = {
  setCountryCode: () => {},
  countryCode: {},
};

FlagSelector.propTypes = {
  setCountryCode: lib.PropTypes.func,
  countryCode: lib.PropTypes.instanceOf(Object),
};
